import React from "react";
import { Lightning, LockSimple } from "@phosphor-icons/react";
import "./videobuy.css";

export const VideoBuyShell = ({ children, ownerName }) => (
  <div className="vb-root min-h-[100dvh] relative overflow-x-hidden" data-testid="video-buy-shell">
    <div className="vb-grid-bg" />
    <header className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 pt-5 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 min-w-0">
        <span className="w-8 h-8 rounded-xl bg-[#FFB30F] flex items-center justify-center shrink-0">
          <Lightning size={18} weight="fill" color="#0B0E14" />
        </span>
        <span className="font-display font-bold text-sm truncate">{ownerName || "MercadoPagu"}</span>
      </div>
      <span className="inline-flex items-center gap-1.5 text-[11px] sm:text-xs text-slate-400 rounded-full border border-white/10 bg-white/[0.03] px-3 py-1.5 shrink-0">
        <LockSimple size={12} className="text-emerald-400" weight="bold" /> Ambiente seguro
      </span>
    </header>
    <main className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 pt-8 sm:pt-12 pb-16">{children}</main>
    <footer className="relative z-10 pb-8 text-center text-[11px] text-slate-500">
      Pagamentos processados por Mercado Pago (Pix) e Stripe (cartão) · Powered by <b className="text-slate-400">MercadoPagu</b>
    </footer>
  </div>
);
